import { NotifyHelper } from "../../../helpers/toast";
import { eGiangVienBanActionsObj } from "../../action-types/category/IGiangVienBanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const giangVienBanActions = {
    ...generateActions(eGiangVienBanActionsObj, "GIANG_VIEN_BAN"),
    ...generateActionForKey(eGiangVienBanActionsObj, "GIANG_VIEN_BAN", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eGiangVienBanActionsObj, "GIANG_VIEN_BAN", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eGiangVienBanActionsObj, "GIANG_VIEN_BAN", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eGiangVienBanActionsObj, "GIANG_VIEN_BAN", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
